import { JSX } from 'react';

/** `Meta` is the platform command key: Cmd on macOS, Ctrl elsewhere. `Option`/`Cmd` are display forms. */
export type ModifierType = 'Shift' | 'Ctrl' | 'Alt' | 'Option' | 'Meta' | 'Cmd';

export type HotkeyModifier = {
  isModifierIconLast?: boolean;
  modifier?: ModifierType;
};

type KeyStroke = {
  code: string;
  keyboardKey: string;
  icon?: JSX.Element;
};

export enum MouseAction {
  // CLICK = 'mouseActions.click',
  DOUBLE_CLICK = 'mouseActions.doubleClick',
  // HOVER = 'mouseActions.hover',
  RIGHT_CLICK = 'mouseActions.rightClick',
}

export type KeyStrokeTree = KeyStroke | { readonly [key: string]: KeyStrokeTree };

export interface HotkeyBase {
  primary: KeyStroke;
  secondary?: KeyStroke;
  optionalPrimary?: KeyStroke;
  hotkeyModifier?: HotkeyModifier;
  secondaryHotkeyModifier?: HotkeyModifier;
  disabled?: boolean;
}
/** `description` is an i18next key with namespace prefix (e.g. `common:shortcuts.camera.tiltCameraUp`). */
export interface Hotkey extends HotkeyBase {
  description: string;
  menuIconForAction?: JSX.Element;
  menuIconBackground?: string;
  mouseAction?: MouseAction;
}

export enum LayoutHotkeyNames {
  NextLayoutKey = 'NextLayoutKey',
  PreviousLayoutKey = 'PreviousLayoutKey',
  ToggleEditModeKey = 'ToggleEditModeKey',
  AddWidgetKey = 'AddWidgetKey',
  ReorganizeWidgetsKey = 'ReorganizeWidgetsKey',
  ResetLayoutKey = 'ResetLayoutKey',
  SaveLayoutKey = 'SaveLayoutKey',
  OpenLayoutIndexModalKey = 'OpenLayoutIndexModalKey',
}

export enum LayoutPickerHotkeyNames {
  FocusSearchKey = 'FocusSearchKey',
  NewLayoutKey = 'NewLayoutKey',
  NewLayoutFromTemplateKey = 'NewLayoutFromTemplateKey',
}

export enum InventoryHotkeyNames {
  FocusSearchKey = 'FocusSearchKey',
  RestoreFocusKey = 'RestoreFocusKey',
  ToggleFlatListKey = 'ToggleFlatListKey',
  ToggleHideLockedKey = 'ToggleHideLockedKey',
}

export enum GlobalHotkeyName {
  DashboardPageKey = 'DashboardPageKey',
  LayoutsPageKey = 'LayoutsPageKey',
  BargeControlsPageKey = 'BargeControlsPageKey',
  CameraControlsPageKey = 'CameraControlsPageKey',
  HybridPowerPageKey = 'HybridPowerPageKey',
  OrbitOnePageKey = 'OrbitOnePageKey',
  PenViewerPageKey = 'PenViewerPageKey',
  AutomationPageKey = 'AutomationPageKey',
  UpCyclePageKey = 'UpCyclePageKey',
  DeviceConfigurationPageKey = 'DeviceConfigurationPageKey',
  EventStreamPageKey = 'EventStreamPageKey',
  InventoryPageKey = 'InventoryPageKey',
  ShowKeyboardShortcutsModalKey = 'ShowKeyboardShortcutsModalKey',
  SettingsPageKey = 'SettingsPageKey',
}

export enum CameraControlHotkeyNames {
  ToggleFullScreen = 'ToggleFullScreenKey',
  AlternativeToggleFullScreen = 'AlternativeToggleFullScreenKey',
  SwitchCamera = 'SwitchCamera',
  CycleCamera = 'CycleCamera',
  FocusNextVideoStream = 'FocusNextVideoStream',
  FocusPreviousVideoStream = 'FocusPreviousVideoStream',
  TiltCameraUp = 'TiltCameraUpKey',
  TiltCameraDown = 'TiltCameraDownKey',
  PanCameraLeft = 'PanCameraLeftKey',
  PanCameraRight = 'PanCameraRightKey',
}

export enum WinchControlHotkeyNames {
  MoveWinchUp = 'MoveWinchUpKey',
  MoveWinchDown = 'MoveWinchDownKey',
  MoveWinchIn = 'MoveWinchIn',
  MoveWinchOut = 'MoveWinchOutKey',
}
